import {Component, output} from '@angular/core';
import {SwipeableComponent} from '../../swipeable/swipeable.component';

@Component({
  selector: 'app-closable-bottom-sheet-handle',
  templateUrl: './closable-bottom-sheet-handle.component.html',
  styleUrl: './closable-bottom-sheet-handle.component.scss',
  imports: [
    SwipeableComponent
  ]
})
export class ClosableBottomSheetHandleComponent {

  close = output()

}
